export default "__VITE_ASSET__B9hU05yu__"